// baseCode

import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import SidebarContent from "./SidebarContent";

const Sidebar = (props) => {
    return (
        <>
            <div className="vertical-menu gt-sidebar">
                <div data-simplebar className="h-100">
                    {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
                </div>
                <div className="sidebar-background"></div>
            </div>
        </>
    );
};

const mapStatetoProps = (state) => {
    return {
        layout: state.Layout
    };
};
export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
